// extracted by mini-css-extract-plugin
export default {"sidebarMenuItem":"styles_sidebarMenuItem__T6Gbn"};